// Alt ansatt-appen kan gjøre, på ett sted. Forsiden bygger knappene herfra, og lista er
// samtidig forslaget til skillet mellom ansatt og leder (planer/ny-kundesamhandling-plan.md).
//
//   gruppe   'hoved' = store knapper øverst (rad 'ordre', 'service' eller 'trykk', se Forside.jsx), 'mer' = mindre knapper under, 'leder' = egen del,
//            'skjult' = ikke på forsiden, bare nådd fra en annen side (f.eks. «Registrer skøyteslip»)
//   tilgang  'alle' eller 'leder' (bare synlig når valgt ansatt har tilgang «leder» — ikke
//            ekte tilgangskontroll, se employeeAccess.js)
//   mekaniker  true = også synlig for rollen «mekaniker» (under «Mer» når de ikke er leder)
//   til      sti å åpne direkte, eller
//   medKunde (kunde) => { til, state } | 'butikkmodus': knappen spør først etter kunde
//   bmodTil  sti på nettsiden butikkmodus åpner (standard /), f.eks. /ski-skoyte?kat=skoyte
//   tilbake  { til, tekst } for «Tilbake»-lenken i «velg kunde» (standard: kontrollpanelet)
//   farge    nøkkel i FARGER, så like oppgaver får samme farge
//   teller   'varsling' | 'nettbutikk': tall på knappen; 'ordrer': den valgte ansattes åpne ordrer,
//            med varseltrekant når noen er eldre enn 7 virkedager (utils/mineOrdrer.js)
//   fremhevet  true = egen, bred knapp først på forsiden som folder ut oppgavene (Gjoremal.jsx)
//   banner   true = smalt banner i full bredde rett under Gjøremål (Forside.jsx)
//   hjorne   id (eller liste med id-er) til andre handlinger som vises som små lenker øverst til
//            høyre i knappen, under hverandre (Knapp.jsx)
//   kortTittel  kort tekst når handlingen vises som hjørnelenke (ellers tittel)
//   ikkeIBruk  true = vises skravert med «Ikke i bruk ennå» og kan ikke trykkes (Knapp.jsx)
//
// Lange sammensatte ord i tittel får myk bindestrek (\u00AD) der de kan deles på smal skjerm:
// «Event-kalender», ikke «Eventkalende-r».

// Forsiden ligger på / (erstattet «Søk / Registrer», 26.10). Oppgaver som spør etter kunde
// først ligger under STI, f.eks. /ny-kundesamhandling/trykk.
export const FORSIDE = '/';
export const STI = '/ny-kundesamhandling';

export const FARGER = {
  verksted: { flate: 'bg-emerald-50 hover:bg-emerald-100 border-emerald-200', ikon: 'bg-emerald-600 text-white' },
  trykk: { flate: 'bg-violet-50 hover:bg-violet-100 border-violet-200', ikon: 'bg-violet-600 text-white' },
  kunde: { flate: 'bg-sky-50 hover:bg-sky-100 border-sky-200', ikon: 'bg-sky-700 text-white' },
  betaling: { flate: 'bg-amber-50 hover:bg-amber-100 border-amber-200', ikon: 'bg-amber-500 text-amber-950' },
  lager: { flate: 'bg-teal-50 hover:bg-teal-100 border-teal-200', ikon: 'bg-teal-700 text-white' },
  info: { flate: 'bg-white hover:bg-slate-50 border-slate-200', ikon: 'bg-slate-700 text-white' },
  leder: { flate: 'bg-white hover:bg-rose-50 border-rose-200', ikon: 'bg-rose-700 text-white' },
};

export const HANDLINGER = [
  // De vanligste oppgavene ved disken. Gjøremål først og størst: det er det første
  // de ansatte skal se når de kommer på jobb.
  { id: 'todo', gruppe: 'hoved', tilgang: 'alle', farge: 'info', ikon: 'avkrysning', fremhevet: true,
    tittel: 'Gjøremål', hjelp: 'Hva som må gjøres i dag', til: '/todo' },
  // To rader under Gjøremål (vinnsel, 28.10): ordre på én linje og service på én linje.
  // rad = 'ordre' | 'service' | 'trykk' (Forside.jsx), og rekkefølgen her er rekkefølgen på raden:
  // «Registrer …» først, lista som nummer 2, så resten (vinnsel, 28.10).
  // Ny ordre er en av de mest brukte (vinnsel, 26.10), så den står først.
  { id: 'ny-ordre', gruppe: 'hoved', rad: 'ordre', tilgang: 'alle', farge: 'betaling', ikon: 'kvittering',
    tittel: 'Registrer ordre', hjelp: 'Bestille vare til kunde', medKunde: (k) => ({ til: `/create-order/${k.customerNumber}` }) },
  { id: 'ordreliste', gruppe: 'hoved', rad: 'ordre', tilgang: 'alle', farge: 'betaling', ikon: 'bunke',
    tittel: 'Ordreliste', hjelp: 'Alle bestillinger', til: '/ordre', teller: 'ordrer' },
  // Ordrevarsler (vinnsel, 29.10): nye meldinger fra kunder på ordrer (kundelenken på SMS).
  // Egen side (/ordrevarsler). Ikke i varslingssenteret (det er for leder).
  { id: 'ordrevarsler', gruppe: 'hoved', rad: 'ordre', tilgang: 'alle', farge: 'betaling', ikon: 'melding',
    tittel: 'Ordrevarsler', hjelp: 'Nye meldinger fra kunder om ordrer', til: '/ordrevarsler', teller: 'ordrevarsler' },

  // Sjekk servicekapasitet som liten lenke øverst til høyre i knappen (vinnsel, 28.10).
  { id: 'service', gruppe: 'hoved', rad: 'service', tilgang: 'alle', farge: 'verksted', ikon: 'skiftenokkel', hjorne: 'kapasitet',
    tittel: 'Registrer service', hjelp: 'Sykkel eller ski inn til verkstedet', medKunde: 'butikkmodus' },
  // Forenklet, bare informasjon: hva som er inne, når det er ferdig, og kommentar til mekanikeren
  // når kunden ringer (vinnsel, 27.10). Het «Servicer på verkstedet» til 28.10.
  { id: 'verkstedet', gruppe: 'hoved', rad: 'service', tilgang: 'alle', farge: 'verksted', ikon: 'info',
    tittel: 'Serviceliste', hjelp: 'Status og ferdigdato når kunden ringer', til: '/verkstedet' },
  // Ikke egen knapp: lenke i hjørnet av «Registrer service» (hjorne), før et banner under Gjøremål.
  { id: 'kapasitet', gruppe: 'skjult', tilgang: 'alle', farge: 'info', ikon: 'kalenderKlokke',
    tittel: 'Sjekk servicekapasitet', kortTittel: 'Sjekk kapasitet', hjelp: 'Når kan servicen min være ferdig?', til: '/sjekk-kapasitet' },
  { id: 'skoyteslip', gruppe: 'hoved', rad: 'service', tilgang: 'alle', farge: 'verksted', ikon: 'skoyte',
    tittel: 'Skøyteslip', hjelp: 'Send ferdigmelding på skøyteslip', til: '/skoyteslip' },

  // Trykk på egen linje (vinnsel, 28.10): registrere (med trykkeguiden og klubbinfo i hjørnet), lista
  // og trykkvarsler.
  { id: 'trykk', gruppe: 'hoved', rad: 'trykk', tilgang: 'alle', farge: 'trykk', ikon: 'genser', hjorne: ['trykkeguide', 'klubbinfo'],
    tittel: 'Registrer trykk', hjelp: 'Navn eller logo på klær',
    medKunde: (k) => ({ til: `/create-service/${k.customerNumber}`, state: { type: 'Tekstiltrykking' } }) },
  { id: 'trykkliste', gruppe: 'hoved', rad: 'trykk', tilgang: 'alle', farge: 'trykk', ikon: 'bunke',
    tittel: 'Trykkliste', hjelp: 'Trykkjobber og klubbordre', til: '/service' },
  // Trykkvarsler (vinnsel, 30.10): nye meldinger fra kunder om trykk (kundelenken på SMS), som
  // Ordrevarsler. Står der Trykkeguide sto; guiden er en lenke i hjørnet av «Registrer trykk».
  { id: 'trykkvarsler', gruppe: 'hoved', rad: 'trykk', tilgang: 'alle', farge: 'trykk', ikon: 'melding',
    tittel: 'Trykkvarsler', hjelp: 'Nye meldinger fra kunder om trykk', til: '/trykkvarsler', teller: 'trykkvarsler' },
  // Ikke egen knapp: lenke i hjørnet av «Registrer trykk» (hjorne), som «Sjekk kapasitet».
  { id: 'trykkeguide', gruppe: 'skjult', tilgang: 'alle', farge: 'trykk', ikon: 'bok',
    tittel: 'Trykkeguide', hjelp: 'Slik trykker vi', til: '/trykkeguide' },
  // Ikke egen knapp: lenke til klubbportalen under «Trykkeguide» i «Registrer trykk» (vinnsel, 02.11).
  { id: 'klubbinfo', gruppe: 'skjult', tilgang: 'alle', farge: 'kunde', ikon: 'folk',
    tittel: 'Klubbinfo', hjelp: 'Klubbene våre: avtaler, trenere og beskjeder', til: '/klubber' },

  // Ikke på forsiden: «Ny kunde» nås fra søkefeltet øverst (vinnsel, 28.10), som bruker denne.
  { id: 'ny-kunde', gruppe: 'skjult', tilgang: 'alle', farge: 'kunde', ikon: 'personPluss',
    tittel: 'Ny kunde', hjelp: 'Registrer navn og telefon', medKunde: (k) => ({ til: `/customer-details/${k._id}` }), nyKunde: true },
  // Servicelisten for mekanikerne (/workshop) står ikke på oversikten (vinnsel, 27.10); den finnes
  // under Verksted i menylinjen. Ruten og siden er uendret.
  { id: 'serviceliste', gruppe: 'skjult', tilgang: 'alle', farge: 'verksted', ikon: 'liste',
    tittel: 'Sykler i verkstedet', hjelp: 'Serviceliste og status', til: '/workshop' },
  // Fra «Ny skøyteslip» på /skoyteslip: velg kunde, så åpnes skøyteslip-bestillingen i
  // butikkmodus. Velges «leveres nå» der, kommer den ansatte til bookingen for mottak.
  { id: 'skoyteslip-ny', gruppe: 'skjult', tilgang: 'alle', farge: 'verksted', ikon: 'skoyte',
    tittel: 'Registrer skøyteslip', hjelp: 'Skøyter inn til sliping', medKunde: 'butikkmodus',
    bmodTil: '/ski-skoyte?kat=skoyte', tilbake: { til: '/skoyteslip', tekst: 'Tilbake til skøyteslip' } },

  // Sjeldnere, men for alle
  // Ta imot service flyttet ned hit (vinnsel, 28.10), så hver linje over har tre like knapper.
  // Skiplukk (vinnsel, 27.10): kunden trenger hjelp til å finne ski. Registreres som en ordre med
  // type «skiplukk» og en oppfølger; kunden velges eller registreres først (navn, telefon, e-post).
  // Flyttet til «Mer» 29.10 (vinnsel).
  { id: 'skiplukk', gruppe: 'mer', tilgang: 'alle', farge: 'lager', ikon: 'snofnugg',
    tittel: 'Skiplukk', hjelp: 'Hjelp kunden å finne riktige ski',
    medKunde: (k) => ({ til: `/create-order/${k.customerNumber}?type=skiplukk` }) },
  { id: 'mottak', gruppe: 'mer', tilgang: 'alle', farge: 'verksted', ikon: 'sykkel',
    tittel: 'Ta imot service', hjelp: 'Booket sykkel, ski og skøyter', til: '/bookingbike' },
  // Dekkhotell, Sykkelhotell og Ta betalt flyttet ned hit (vinnsel, 26.10).
  { id: 'dekkhotell', gruppe: 'mer', tilgang: 'alle', farge: 'lager', ikon: 'dekk',
    tittel: 'Dekkhotell', hjelp: 'Lagre eller hente dekk', til: '/dekkhotell' },
  { id: 'sykkelhotell', gruppe: 'mer', tilgang: 'alle', farge: 'lager', ikon: 'hotell',
    tittel: 'Sykkelhotell', hjelp: 'Vinterlagring av sykler', til: '/sykkelhotell' },
  { id: 'pristilbud', gruppe: 'mer', tilgang: 'alle', farge: 'verksted', ikon: 'dokument',
    tittel: 'Pristilbud', hjelp: 'Tilbud sendt til kunder', til: '/offer-list' },
  { id: 'avtaler', gruppe: 'mer', tilgang: 'alle', farge: 'info', ikon: 'handtrykk',
    tittel: 'Avtaler', hjelp: 'Klubb- og firmaavtaler', til: '/avtaler' },
  // Klubbportalen (vinnsel, 02.11, planer/klubbportal-plan.md): beskjeder, trenere og innkjøpsansvarlige.
  { id: 'klubber', gruppe: 'mer', tilgang: 'alle', farge: 'kunde', ikon: 'folk',
    tittel: 'Klubber', hjelp: 'Beskjeder, trenere og avtaler', til: '/klubber' },
  { id: 'eventkalender', gruppe: 'mer', tilgang: 'alle', farge: 'info', ikon: 'kalender',
    tittel: 'Event\u00ADkalender', til: '/eventcalendar' },
  { id: 'send-sms', gruppe: 'mer', tilgang: 'alle', farge: 'kunde', ikon: 'send',
    tittel: 'Send SMS', til: '/sendsms' },
  { id: 'kalkyle', gruppe: 'mer', tilgang: 'alle', farge: 'betaling', ikon: 'kalkulator',
    tittel: 'Kalkyle\u00ADkalkulator', til: '/hjelpemidler' },

  // Leder: priser, oppsett, rapporter og nettbutikk
  { id: 'meldinger', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'melding',
    tittel: 'Meldinger', hjelp: 'Chat og akutt fra kunder', til: '/varsling', teller: 'varsling' },
  { id: 'nettbutikk-salg', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'butikk',
    tittel: 'Nettbutikk: salg', til: '/nettbutikk-salgsrapport', teller: 'nettbutikk' },
  { id: 'nettbutikk-produkter', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'eske',
    tittel: 'Nettbutikk: produkter', til: '/produkter' },
  { id: 'nettbutikk-kategorier', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'lapp',
    tittel: 'Nettbutikk: kategorier', til: '/kategorier' },
  { id: 'nettbutikk-import', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'import',
    tittel: 'Nettbutikk: import', til: '/varelager' },
  { id: 'statistikk', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'diagram',
    tittel: 'Verksted\u00ADstatistikk', til: '/workshop-statistikk' },
  // Erstattet «Fastpris arbeid» og redigeringen i Hygraph (planer/hygraph-plan.md). Mekaniker ser den også.
  { id: 'tjenester', gruppe: 'leder', tilgang: 'leder', mekaniker: true, farge: 'leder', ikon: 'lapp',
    tittel: 'Tjenester og priser', hjelp: 'Priser, kapasitet og stengte dager', til: '/tjenester' },
  { id: 'ansatte', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'folk',
    tittel: 'Ansatte', til: '/employees' },
  { id: 'sms-maler', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'mal',
    tittel: 'SMS-maler', til: '/sms-templates' },
  { id: 'sperrede', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'las',
    tittel: 'Sperrede poster', hjelp: 'Regnskapsmateriale', til: '/regnskap/sperrede' },
  { id: 'varelager', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'eske',
    tittel: 'Varelager', til: '/lager' },
  { id: 'klubb', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'folk',
    tittel: 'Klubb: bestillinger', til: '/klubb/bestillinger' },
  { id: 'plakater', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'bilde',
    tittel: 'Plakater', til: '/plakater' },
  // Flyttet fra «Mer» til «Leder» (vinnsel, 30.10). Reklamasjon finnes også under Verksted i menylinjen.
  { id: 'reklamasjon', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'skjold',
    tittel: 'Reklamasjon', hjelp: 'Garantisak på sykkel', til: '/reklamasjon-sykkel' },
  { id: 'betal', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'kort',
    tittel: 'Ta betalt', hjelp: 'Røyken Sykkelservice', til: '/betal', ikkeIBruk: true },
  // Gamle sykkel-, ski- og skøyteservicer (vinnsel, 28.10): fases ut og slettes når de er ryddet opp.
  { id: 'gammel-hardvare', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'eske',
    tittel: 'Gammel hardvare', hjelp: 'Fases ut', til: '/gammel-hardvare' },
  // Flyttet fra «Mer» til «Leder» (vinnsel, 30.10). Finnes også under Verksted i menylinjen.
  { id: 'sykkelkort', gruppe: 'leder', tilgang: 'leder', farge: 'leder', ikon: 'idkort',
    tittel: 'Alle sykkelkort', til: '/sykkelkort' },
];

export const finnHandling = (id) => HANDLINGER.find((h) => h.id === id);

// Det den valgte ansatte skal se. Leder ser alt; mekaniker også det som er merket mekaniker.
export const synligeHandlinger = (leder, mekaniker = false) =>
  HANDLINGER.filter((h) => h.tilgang === 'alle' || leder || (mekaniker && h.mekaniker));
